var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeezerColorLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 50,
    viewBox: "0 0 110 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Deezer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "deezer-color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Deezer_logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8175",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0045 35C27.9921 35 25.2917 32.3613 25.2917 27.9524C25.2917 23.4775 28.1124 20.7838 32.0264 20.7948C34.0271 20.7948 35.6233 21.4545 36.487 22.9277V14H40.2917V35H36.6292V32.966C35.6889 34.4393 34.0052 35 32.0045 35ZM32.8573 32.0424C34.9017 32.0424 36.6073 30.4702 36.6073 27.9524C36.6073 25.4126 34.9017 23.7853 32.8573 23.7853C30.7472 23.7853 29.1073 25.3906 29.1073 27.9524C29.1073 30.4702 30.7363 32.0424 32.8573 32.0424Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8177",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8034 32.0595C51.5343 32.0595 52.6338 31.2595 53.0693 29.6595L56.2917 30.9243C55.3119 33.6378 53.0802 35 49.7925 35C45.4379 35 42.2917 32.3405 42.2917 27.9081C42.2917 23.9297 45.1439 21 49.2917 21C53.1782 21 55.8127 23.1622 55.8127 27C55.8127 27.6162 55.7583 28.1784 55.6385 28.7081H46.0911C46.1346 30.8486 47.7894 32.0595 49.8034 32.0595ZM49.3026 23.7459C47.7458 23.7459 46.4503 24.6541 46.0911 26.2H52.1331L52.1548 26.0811C52.1548 24.6541 51.0009 23.7459 49.3026 23.7459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8179",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8034 32.0595C65.5343 32.0595 66.6338 31.2595 67.0693 29.6595L70.2917 30.9243C69.3119 33.6378 67.0802 35 63.7925 35C59.4379 35 56.2917 32.3405 56.2917 27.9081C56.2917 23.9297 59.1439 21 63.2917 21C67.1782 21 69.8127 23.1622 69.8127 27C69.8127 27.6162 69.7583 28.1784 69.6385 28.7081H60.0911C60.1346 30.8486 61.7894 32.0595 63.8034 32.0595ZM63.3026 23.7459C61.7458 23.7459 60.4503 24.6541 60.0911 26.2H66.1331L66.1548 26.0811C66.1548 24.6541 65.0009 23.7459 63.3026 23.7459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8181",
    d: "M82.2917 35V31.5946H74.775L82.086 24.1135V21H70.5179V24.2432H77.5822L70.2917 31.7568V35H82.2917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8183",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8034 32.0595C92.5343 32.0595 93.6338 31.2595 94.0693 29.6595L97.2917 30.9243C96.3119 33.6378 94.0802 35 90.7925 35C86.4379 35 83.2917 32.3405 83.2917 27.9081C83.2917 23.9297 86.1439 21 90.2917 21C94.1782 21 96.8127 23.1622 96.8127 27C96.8127 27.6162 96.7583 28.1784 96.6385 28.7081H87.0911C87.1346 30.8486 88.7894 32.0595 90.8034 32.0595ZM90.3026 23.7459C88.7458 23.7459 87.4503 24.6541 87.0911 26.2H93.1331L93.1548 26.0811C93.1548 24.6541 92.0009 23.7459 90.3026 23.7459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8185",
    x: 18.2917,
    y: 20,
    width: 4,
    height: 4,
    fill: "#40AB5D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8192",
    x: 18.2917,
    y: 23,
    width: 4,
    height: 4,
    fill: "url(#paint0_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8199",
    x: 18.2917,
    y: 28,
    width: 4,
    height: 4,
    fill: "url(#paint1_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8206",
    x: 0.291687,
    y: 31,
    width: 4,
    height: 4,
    fill: "url(#paint2_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8213",
    x: 5.29169,
    y: 31,
    width: 4,
    height: 4,
    fill: "url(#paint3_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8220",
    x: 11.2917,
    y: 31,
    width: 4,
    height: 4,
    fill: "url(#paint4_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8227",
    x: 18.2917,
    y: 31,
    width: 4,
    height: 4,
    fill: "url(#paint5_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8234",
    x: 11.2917,
    y: 28,
    width: 4,
    height: 4,
    fill: "url(#paint6_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8241",
    x: 5.29169,
    y: 28,
    width: 4,
    height: 4,
    fill: "url(#paint7_linear_107_350)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8248",
    x: 5.29169,
    y: 23,
    width: 4,
    height: 4,
    fill: "url(#paint8_linear_107_350)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8250",
    d: "M105.682 25.8183C105.682 25.959 105.682 26.2189 105.682 26.2189H109.292C109.292 26.2189 109.292 25.5259 109.292 25.1469C109.292 22.7432 107.812 21 105.33 21C103.733 21 102.604 21.7904 102.019 23.1005V21H98.2917V35H102.019V25.9807C102.019 24.5514 102.775 23.761 103.935 23.761C105 23.7718 105.682 24.7896 105.682 25.8183Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_350",
    x1: 22.3579,
    y1: 27.0157,
    x2: 22.3203,
    y2: 22.9225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#358C7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5256,
    stopColor: "#33A65E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_350",
    x1: 20.0266,
    y1: 33.8543,
    x2: 24.146,
    y2: 30.2669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_107_350",
    x1: 0.292419,
    y1: 34.9999,
    x2: 4.28907,
    y2: 34.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_107_350",
    x1: 5.29614,
    y1: 34.9999,
    x2: 9.2928,
    y2: 34.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_107_350",
    x1: 11.2905,
    y1: 34.9999,
    x2: 15.2872,
    y2: 34.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_107_350",
    x1: 18.2895,
    y1: 34.9999,
    x2: 22.2862,
    y2: 34.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3559A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_107_350",
    x1: 12.2104,
    y1: 33.2346,
    x2: 16.5225,
    y2: 31.0794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_107_350",
    x1: 3.82225,
    y1: 30.8098,
    x2: 8.10342,
    y2: 33.4731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00266984,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CE1938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_107_350",
    x1: 3.0102,
    y1: 24.0408,
    x2: 6.33501,
    y2: 29.2845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00266984,
    stopColor: "#FFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5A22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeezerColorLight);
export default __webpack_public_path__ + "static/media/deezer-color-light.c3e2f7ae29b3cc60aff8fe877168202a.svg";
export { ForwardRef as ReactComponent };